import { DialogProps } from '@mui/material/Dialog';
import { Theme } from '@mui/material/styles';
import { useModal } from 'mui-modal-provider';
import { makeStyles } from 'tss-react/mui';
import { AiSmartReplyPlan, AiSmartReplyPlanItem } from '../../../../sic-lib/api/ai/types/Ai';
import { useAiPrompt } from '../../../../sic-lib/api/hooks/useAiPrompts';
import { useAiDeleteSmartReplyPlanItem } from '../../../../sic-lib/api/hooks/useAiSmartReply';
import ButtonLoading from '../../../Shared/ButtonLoading';
import DialogConfirmAction from '../../../Shared/DialogConfirmAction/DialogConfirmAction';
import { DrawerCommon } from '../../../Shared/Drawer/DrawerCommon';
import Loader from '../../../Shared/Loader';
import AiCreateEditPrompt from '../Prompts/AiCreateEditPrompt';

interface Props extends DialogProps {
    planItem: AiSmartReplyPlanItem | undefined;
    plan: AiSmartReplyPlan;
    onCancel: (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onConfirm: (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
export function EditSmartReplyPlanItemDrawer({
    planItem,
    plan,
    onCancel,
    onConfirm,
    ...props
}: Props) {
    const { showModal } = useModal();
    const { classes } = useStyles();
    const { data: prompt, isPending: isLoading } = useAiPrompt(planItem?.promptId || 0);
    const {
        mutate: deletePlanItem,
        isPending: isLoadingDeletePlanItem,
        isSuccess: isSuccessDelete,
        error,
        reset,
    } = useAiDeleteSmartReplyPlanItem();

    const handleClose = () => {
        onCancel();
    };

    const handleConfirmDelete = () => {
        const modal = showModal(DialogConfirmAction, {
            title: 'Please Confirm',
            description: 'Are you sure you want to delete this plan item?',
            onConfirm: () => {
                deletePlanItem(
                    { planId: planItem!.planId!, planItemId: planItem!.planItemId! },
                    {
                        onSuccess: () => {
                            reset(); //reset the button's "Success"
                            onConfirm();
                        },
                    },
                );
            },
            onCancel: () => {
                modal.hide();
            },
        });
    };

    return (
        <>
            <DrawerCommon
                title="SmartReply Item"
                handleOnClose={handleClose}
                width="1200px"
                titleNodes={
                    <ButtonLoading
                        variant="contained"
                        color="error"
                        isLoading={isLoadingDeletePlanItem}
                        isSuccess={isSuccessDelete}
                        successLabel="Deleted"
                        isError={!!error}
                        onClick={handleConfirmDelete}
                    >
                        Delete Item
                    </ButtonLoading>
                }
                {...props}
            >
                <Loader isLoading={isLoading} />
                {!isLoading && prompt && <AiCreateEditPrompt aiPrompt={prompt} />}
            </DrawerCommon>
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
